import React from 'react';

const DigitalTransformation = () => {
  return (
    <div className="page-content">
      <section className="hero-small">
        <div className="container">
          <h1>Digital Transformation</h1>
          <p>Reimagine your business with comprehensive digital transformation strategies.</p>
        </div>
      </section>
      
      <section className="services-detail">
        <div className="container">
          <div className="service-grid">
            <div className="service-card">
              <h3>Strategy & Consulting</h3>
              <p>Digital roadmap and transformation planning</p>
            </div>
            <div className="service-card">
              <h3>Process Automation</h3>
              <p>Streamline operations with intelligent automation</p>
            </div>
            <div className="service-card">
              <h3>Legacy Modernization</h3>
              <p>Modernize legacy systems for digital readiness</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DigitalTransformation;